import { Order } from '@diamond/shared/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { getOrderDetail } from '../queries/order';
import { useAuthStore } from '../stores';

export const getOrderDetailQueryKey = (metaId: string, warehouse: string) =>
  ['OrderDetail', metaId, warehouse] as const;

export function getOrderDetailOptions(
  access_token: string,
  metaId: string,
  warehouse: string,
  shouldRunQuery = true
) {
  return queryOptions<Order>({
    queryKey: getOrderDetailQueryKey(metaId, warehouse),
    queryFn: () => getOrderDetail(access_token, metaId, warehouse),
    enabled: shouldRunQuery,
  });
}

export const useGetOrderDetail = (
  metaId: string,
  warehouse: string,
  shouldRunQuery = true
) => {
  const session = useAuthStore();

  return useQuery(
    getOrderDetailOptions(
      session.access_token,
      metaId,
      warehouse,
      shouldRunQuery
    )
  );
};
